import React from 'react';
import * as styles from './style.module.scss';
import { allCategoriesUri } from '../../utils/urls';
import {
    googleMapAddressRoute,
    telPhoneUrl,
} from '../../utils/static';
import { LayoutContext } from '../layout-context';
import { sendEvent } from '../../utils/ga';
import Link from '../Link';

export default function BottomNavigation() {
    const handleClickButton = (type, showOnlineConsultModal) => {
        if (type === 'contact') {
            window.location.href = telPhoneUrl;
        } else if (type === 'map') {
            window.open(`https://${googleMapAddressRoute}`);
        } else if (type === 'consult') {
            sendEvent('Mobile Callout Block', 'click', 'online consult');
            showOnlineConsultModal();
        }
    };
    return (
        <LayoutContext.Consumer>
            {({ showOnlineConsultModal }) => (
                <section className={styles.wrapper}>
                    <div id="tabs" className={styles.innerWrapper}>
                        <Link to={allCategoriesUri} className={styles.link}>
                            <svg xmlns="http://www.w3.org/2000/svg" className={styles.svg} fill="none" width="25" height="25" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                            </svg>
                            <span className={styles.linkText}>所有產品</span>
                        </Link>
                        <button type="button" className={styles.link} onClick={() => handleClickButton('map')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className={styles.svg} fill="none" width="25" height="25" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <span className={styles.linkText}>公司地址</span>
                        </button>
                        <button type="button" className={styles.link} onClick={() => handleClickButton('contact')}>
                            <svg xmlns="http://www.w3.org/2000/svg" className={styles.svg} fill="none" width="25" height="25" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            <span className={styles.linkText}>聯絡我們</span>
                        </button>
                        <button type="button" className={styles.link} onClick={() => handleClickButton('consult', showOnlineConsultModal)}>
                            <svg xmlns="http://www.w3.org/2000/svg" className={styles.svg} fill="none" width="25" height="25" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span className={styles.linkText}>線上詢價</span>
                        </button>
                    </div>
                </section>
            )}
        </LayoutContext.Consumer>
    );
}
